import { BaseService } from './base-service';
class PublicService extends BaseService {
  /**
   * @description: 获取表头
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getField(data) {
    return this.request({
      method: 'get',
      url: `/sys-entity/entity`,
      params: data
    });
  }
  /**
   * @description: 获取表头
   * @param {*} data
   * @return {*}
   * @author: NN
   */
  getSysEntityFormFields(data) {
    return this.request({
      method: 'get',
      url: `/sys-entity/form/fields`,
      params: data
    });
  }
  /**
   * @description: //获取联系人
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getContactList(data) {
    return this.request({
      method: 'get',
      url: `/contact/list`,
      params: data
    });
  }
  /**
   * @description:  //详情--通话记录--外呼接口
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  callOut(data) {
    return this.request({
      method: 'post',
      url: `/outCall/callOut`,
      data
    });
  }
  /**
   * @description:    //新增联系人
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getContactAdd(data) {
    return this.request({
      method: 'post',
      url: `/contact/add`,
      data
    });
  }

  /**
   * @description: //编辑联系人
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getContactUpdate(data) {
    return this.request({
      method: 'post',
      url: `/contact/update`,
      data
    });
  }
  /**
   * @description:  设为默认联系人
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  getContactDefault(data) {
    return this.request({
      method: 'post',
      url: `/contact/default`,
      data
    });
  }
  /**
   * @description: 删除联系人
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  deleteContact(data) {
    return this.request({
      method: 'post',
      url: `/contact/delete`,
      data
    });
  }
  /**
   * @description: 通话记录
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  getOutCallDetail(data) {
    return this.request({
      method: 'post',
      url: `/outCall/getOutCallDetail`,
      data
    });
  }
  /********************************
   * 云山松的米糠云外呼相关api
   ********************************/
  /**
   * @description: 米糠外呼-工号查询
   * @return {*}
   * @author: ylq
   */

  getMkyOutBound(data) {
    return this.request({
      method: 'post',
      url: `/sysOutBound/listDetail`,
      data
    });
  }
  /**
   * @description: 米糠外呼-业务值提前预置
   * @return {*}
   * @author: ylq
   */

  saveMkyOutBefore(data) {
    return this.request({
      method: 'post',
      url: `/out/before/add`,
      data
    });
  }
  /**
   * @description: - 批量删除
   * @return {*}
   * @author: jnn
   */
  removeBatch(data) {
    return this.request({
      method: 'post',
      url: `/dynamic/entity/data/removeBatch`,
      data
    });
  }
  /***************************流程阶段*****************************************/
  /**
   * @description: 对象推进器详情接口
   * @return {*}
   * @author: nn
   */
  flowDetail(params) {
    return this.request({
      method: 'get',
      url: `/entity/process/propeller/detail`,
      params
    });
  }
  /**
   * @description: 推进回退接口
   * @return {*}
   * @author: nn
   */
  commitOrRollback(data) {
    return this.request({
      method: 'post',
      url: `/entity/process/propeller/commitOrRollback`,
      data
    });
  }
  /**
   * @description: 终止接口
   * @return {*}
   * @author: nn
   */
  terminate(data) {
    return this.request({
      method: 'post',
      url: `/entity/process/propeller/terminate`,
      data
    });
  }
  /**
   * @description: 激活流程
   * @return {*}
   * @author: nn
   */
  activate(params) {
    return this.request({
      method: 'get',
      url: `/entity/process/propeller/activate`,
      params
    });
  }
  /**
   * @description: 获取节点下的任务
   * @return {*}
   * @author: nn
   */
  getNodeTableListByNodeId(params) {
    return this.request({
      method: 'get',
      url: `/processStagePropeller/getNodeTableListByNodeId`,
      params
    });
  }
  /**
   * @description: 操作节点负责人
   * @return {*}
   * @author: nn
   */

  updateNodeOwners(data) {
    return this.request({
      method: 'post',
      url: `/entity/process/propeller/updateNodeOwners`,
      data
    });
  }
  /**
   * @description: 查找业务数据操作日志
   * @return {*}
   * @author: nn
   */

  getOperationLog(data) {
    return this.request({
      method: 'post',
      url: `/entity/process/propeller/operationLog`,
      data
    });
  }

  /**
   * @description: 负责人催一催
   *
   */
  warnToNodeOwner(params) {
    return this.request({
      method: 'get',
      url: `/processStagePropeller/warnToNodeOwner`,
      params
    });
  }

  /**
   * @description: 修改选择的对象值
   * @return {*}
   * @author: nn
   */
  updateTableValue(data) {
    return this.request({
      method: 'post',
      url: `/processStagePropeller/updateTableValue`,
      data
    });
  }
  /**
   * @description: 完成任务
   * @return {*}
   * @author: nn
   */
  doneTableById(params) {
    return this.request({
      method: 'get',
      url: `/processStagePropeller/doneTableById`,
      params
    });
  }

  /***************************流程阶段*****************************************/
  /********************************
   * 飞书webhook机器人
   ********************************/
  /**
   * @description: 飞书webhook机器人
   * @return {*}
   * @author: ylq
   */
  sendFeiShuHookMsg(data) {
    return this.request({
      method: 'post',
      url: `/fsbot/6617d19a-2aa1-481d-9b63-260771ae286d`,
      data
    });
  }
  /**
   *@description: 获取日志列表
   *@author：qsj
   */
  findBusinessOperationLog(data) {
    return this.request({
      method: 'post',
      url: `/es/findBusinessOperationLog`,
      data
    });
  }
  /**
   * @description: 飞书webhook机器人前端测试机器人
   * @return {*}
   * @author: ylq
   */
  sendFeiShuFeMsg(data) {
    return this.request({
      method: 'post',
      url: `/fsbot/f3e6dfbc-77fb-4ab7-9a6f-afd2ef939173`,
      data
    });
  }

  /********************************
   * 动态记录
   ********************************/
  /**
   * @description: 添加动态记录
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  addFollow(data) {
    return this.request({
      method: 'post',
      url: `/clue_record/add`,
      data
    });
  }
  /**
   * @description:  跟新动态记录
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  updateFollow(data) {
    return this.request({
      method: 'post',
      url: `/clue_record/update`,
      data
    });
  }
  /**
   * @description: 获取动态记录列表
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  getFollowList(data) {
    return this.request({
      method: 'get',
      url: `/clue_record/list`,
      params: data
    });
  }
  /**
   *  动态记录评论--添加评论
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof publicService
   */
  addCommentRecord(data) {
    return this.request({
      method: 'post',
      url: `/comment/add`,
      data
    });
  }
  /**
   *  动态记录--获取动态记录列表
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof publicService
   */
  getCommentList(data) {
    return this.request({
      method: 'post',
      url: `/comment/list`,
      data
    });
  }
  /**
   *  动态记录--评论点赞
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof publicService
   */
  commentLike(data) {
    return this.request({
      method: 'post',
      url: `/comment/like`,
      data
    });
  }
  /**
   *  动态记录--取消评论点赞
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof publicService
   */
  commentCancelLike(data) {
    return this.request({
      method: 'post',
      url: `/comment/cancelLike`,
      data
    });
  }
  /********************************
   * 日程页签
   ********************************/
  /**
   * @description: 获取日程列表
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  getCalenderDetailByStatus(data) {
    return this.request({
      method: 'post',
      url: `/calender/getCalenderDetailByStatus`,
      data
    });
  }
  /**
   * @description: 新建日程
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  addCreatEvent(data) {
    return this.request({
      method: 'post',
      url: `/calender/creatEvent`,
      data
    });
  }
  /**
   * @description: 编辑日程
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  updateCalender(data) {
    return this.request({
      method: 'post',
      url: `/calender/updateCalender`,
      data
    });
  }
  /**
   * @description: 删除日程
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */

  deleteCalender(data) {
    return this.request({
      method: 'post',
      url: `/calender/deleteCalender`,
      data
    });
  }
  /**
   * @description: 转移/批量转移
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  updateFollowUser(data) {
    return this.request({
      method: 'post',
      url: `/transfer/user`,
      data
    });
  }
  updateFollowUserAll(data) {
    return this.request({
      method: 'post',
      url: `/transfer/totalUser`,
      data
    });
  }
  /**
   *  公共导入--模板下载
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param
   * @returns
   * @memberof publicService
   */
  getLeadInTemplate(data) {
    return this.request({
      method: 'get',
      url: `/entity/upload/download/template`, // 老接口：/entity/upload/get_template
      responseType: 'blob',
      params: data
    });
  }
  /**
   *  公共导入--导入进度接口
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param
   * @returns
   * @memberof publicService
   */
  getDownloadProgress(data) {
    return this.request({
      method: 'post',
      url: `/entity/upload/download_progress`,
      data
    });
  }
  /**
   * @description: 根据id获取当前对象的列表（label，value）
   * @param {*} data
   * @return {*}
   * @author: ylq
   */
  getSimpleListByEntity(data) {
    return this.request({
      method: 'get',
      url: `/entity/queryType`,
      params: data // { apiIndex: data?.apiIndex || data.entity },
      //
    });
  }
  /**
   * @description: 根据id获取当前id的搜索数据
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getListByEntity(data) {
    return this.request({
      method: 'post',
      url: `/entity/related`,
      params: { apiIndex: `${data.entity}_${data.apiIndex || ''}` },
      data
    });
  }
  /**
   * @description: 根据id获取当前id的搜索数据
   * @param {*} data
   * @return {*}
   */
  getListByEntityId(data) {
    let url = `/entity/related`;
    let method = 'post';
    let d;
    let p = { apiIndex: `${data.entity}-${data.apiIndex || Math.random() * 100}` };
    if (data.customerId) {
      method = 'get';
      if (data.entity == 3) url = '/entity/opportunityByCustomer';
      if (data.entity == 8) url = '/entity/contractByCustomer';
      if (data.entity == 6) url = '/entity/priceSheetByCustomer?';
      p = { ...data, ...p };
    } else {
      d = data;
    }
    //兼容自定义对象
    if (data.entity >= 200) {
      url = '/entity/relatedByEntity';
    }
    return this.request({
      method,
      url,
      params: p,
      data: d
    });
  }
  /**
   * @description: 根据entity 获取主字段label
   * @param {*} data
   * @return {*}
   * @author: zl
   */
  getPrimaryByEntity(data) {
    return this.request({
      method: 'POST',
      url: `/entity/selectPrimaryByEntity`,
      data
    });
  }
  /**
   * @description: 根据customerId获取当前商机列表
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getOpportunityByCustomerId(data) {
    return this.request({
      method: 'get',
      url: `/entity/selectEntityCustomOpp`,
      params: data
    });
  }
  /**
   * @description: 根据customerId获取当前报价单列表
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getPriceSheetByCustomerId(data) {
    return this.request({
      method: 'get',
      url: `/entity/selectEntityCustomPriceSheet`,
      params: data
    });
  }
  /**
   *  根据customerId获取当前销售合同列表
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof publicService
   */
  getContractByCustomerId(params) {
    return this.request({
      method: 'get',
      url: `/order/selectContract`,
      params
    });
  }
  /********************************
   * 查重按钮
   ********************************/
  /**
   *  查重接口
   *
   * @author ldd
   * @param  {Object} data
   * @returns
   * @memberof LeadsService
   */
  //线索查重
  setClueRepeat(data) {
    return this.request({
      method: 'post',
      url: `/clue/repeat`,
      data
    });
  }
  //客户查重
  setCustomerRepeat(data) {
    return this.request({
      method: 'post',
      url: `/customer/repeat`,
      data
    });
  }
  /********************************
   * 获取租户的付费信息
   ********************************/
  /**
   *  获取租户的付费信息
   *
   * @author ylq
   * @param  {Object} params
   * @returns
   * @memberof publicService
   */
  getTenantInfo(params) {
    return this.request({
      method: 'get',
      url: `home/tenantInfo`,
      params
    });
  }

  /********************************
   * 引用字段值查询
   ********************************/
  getReferenceField(params) {
    return this.request({
      method: 'get',
      url: `/dynamic/query/reference/field`,
      params
    });
  }
  /**
   *  获取全局字段选项
   *
   * @author caoJianBo
   * @param  {Object} params
   * @returns
   * @memberof publicService
   */
  getSelections(params) {
    return this.request({
      method: 'get',
      url: `/global_field/selections`,
      params
    });
  }
  /**
   * @description: 获取部门及负责人信息
   * @param {*} params
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getDepartment(data) {
    return this.request({
      method: 'post',
      url: `/sysDepartment/getDept`,
      data
    });
  }
  /**
   *  密码错误，重新登录
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param
   * @returns
   * @memberof publicService
   */
  changePassword(data) {
    return this.request({
      method: 'post',
      url: `/auth/reLogin`,
      data
    });
  }
  /**
   *  当前登录人下的租户列表
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @param
   * @returns
   * @memberof publicService
   */
  getSwitchUserList(params) {
    return this.request({
      method: 'get',
      url: `/auth/changeOrgs`,
      params
    });
  }
  /**
   *  Bing--UI后台详情
   *
   * @author jinannan
   * @param  {Object} params
   * @returns
   * @memberof publicService
   */
  getUrl(data) {
    return this.request({
      method: 'post',
      url: `/bing/getUrl`,
      data
    });
  }
  /**
   *  Bing--数据同步
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof publicService
   */
  refreshData(data) {
    return this.request({
      method: 'post',
      url: `/bing/refreshData`,
      data
    });
  }
  /**
   *  高级筛选下拉
   *
   * @author caoJianBo
   * @param  {Object} params
   * @returns
   * @memberof publicService
   */
  getConditionList(params) {
    return this.request({
      method: 'get',
      url: `/condition/list`,
      params
    });
  }
  /**
   *  新增筛选条件
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof publicService
   */
  addConditionSave(data) {
    return this.request({
      method: 'post',
      url: `/condition/save`,
      data
    });
  }
  /**
   *  编辑筛选条件
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof publicService
   */
  updateCondition(data) {
    return this.request({
      method: 'post',
      url: `/condition/update`,
      data
    });
  }
  /**
   *  删除筛选条件
   *
   * @author caoJianBo
   * @param  {Object} params
   * @returns
   * @memberof publicService
   */
  deleteCondition(params) {
    return this.request({
      method: 'get',
      url: `/condition/delete`,
      params
    });
  }
  /**
   *  更新常用检索是否默认
   *
   * @author caoJianBo
   * @param  {Object} data
   * @returns
   * @memberof publicService
   */
  updateStatusCondition(data) {
    return this.request({
      method: 'post',
      url: `/condition/updateStatus`,
      data
    });
  }
  /**
   * @brief 获取所有的对象字段
   */
  getAllEntityFields(params) {
    return this.request({
      method: 'GET',
      url: `clue_setting/field/getByOrgId?apiIndex=${Math.random()}`,
      params
    });
  }

  /**
   * @brief 获取所有的对象字段V2
   */

  // getEntitySettingFields(data) {
  //   return this.request({
  //     method: 'POST',
  //     url: `/entity/settings/info`,
  //     data
  //   });
  // }

  /**
   * @brief 查找关联单选字段
   */
  getAssociationRadioFields(params) {
    return this.request({
      method: 'GET',
      url: `/entity/association/title?apiIndex=${Math.random()}`,
      params
    });
  }
  /**
   * @brief 查找关联单选字段列表
   */
  getAssociationRadio(data) {
    return this.request({
      method: 'POST',
      url: '/entity/association',
      data,
      params: { apiIndex: Math.random() }
    });
  }
  /**
   * @brief 查找关联单选赋值接口
   */
  getAssociationAssign(data) {
    return this.request({
      method: 'POST',
      url: '/dynamic/query/field/assignment',
      data,
      params: { apiIndex: data?.entity || undefined }
    });
  }
  getAssociationAssignNew(data) {
    return this.request({
      method: 'POST',
      url: '/dynamicFieldExtend/query/field/assignment',
      data,
      params: { apiIndex: data?.entity || undefined }
    });
  }
  //批量处理查找关联赋值
  getAssociationAssign4Bulk(data) {
    return this.request({
      method: 'POST',
      url: '/dynamicFieldExtend/query/field/assignmentList',
      data
    });
  }
  /**
   *  详情页面--获取详情中关联表格中的数据
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getTableEntityData(params) {
    return this.request({
      method: 'get',
      url: `/dynamic/getTableEntityData`,
      params
    });
  }

  /**
   * @brief 合同添加报价单明细，订单添加报价单明细，订单添加合同明细公共接口
   */
  getDetailAutoFill(data) {
    return this.request({
      method: 'get',
      url: `/autoFill/get`,
      params: data
    });
  }
  /**
   *  获取动态记录表头
   */
  tableHead(params) {
    return this.request({
      method: 'get',
      url: '/dynamicRecord/tableHead',
      params
    });
  }
  /**
   * @brief 查询筛选条件
   */
  getConditionParamsList(params) {
    return this.request({
      method: 'GET',
      url: '/condition/get',
      params
    });
  }
  /**
   * @brief 保存当前用户的筛选条件
   */
  setConditionParamsList(data) {
    return this.request({
      method: 'POST',
      url: '/condition/add',
      data,
      params: { apiIndex: Math.random() }
    });
  }

  /**
   * @brief 任务中心列表
   */
  taskList(data) {
    return this.request({
      method: 'POST',
      url: '/task-center/list',
      data
    });
  }
  /**
   * @brief 根据id获取任务列表
   */
  taskListByIds(data) {
    return this.request({
      method: 'POST',
      url: '/task-center/queryByIds',
      data
    });
  }
  /**
   * @brief 任务状态列表
   */
  taskStatusList() {
    return this.request({
      method: 'GET',
      url: '/task-center/taskStatus'
    });
  }
  /**
   * @brief 更新任务已读状态
   */
  updateReadStatus() {
    return this.request({
      method: 'GET',
      url: '/task-center/updateReadStatus'
    });
  }
  /**
   * @brief 下载任务异常文件
   */
  downloadErrorFile(taskCenterId) {
    return this.request({
      method: 'GET',
      // responseType: 'blob',
      url: `/task-center/exportFile/error/${taskCenterId}`
    });
  }
  /**
   * @brief 任务重试
   */
  retryTask(params) {
    return this.request({
      method: 'GET',
      url: `/task-center/taskAgain`,
      params
    });
  }
  /**
   * @brief 获取推送消息
   */
  getPushMsg(params) {
    return this.request({
      method: 'GET',
      url: `/task-center/pushMsg`,
      params
    });
  }
  /**
   * @brief 获取消息读取状态
   */
  getReadStatus() {
    return this.request({
      method: 'GET',
      url: `/task-center/getReadStatus`
    });
  }
  // 获取人员列表
  getUserList(data) {
    return this.request({
      method: 'POST',
      url: `/userExtend/list`,
      data
    });
  }
  // 上传图片
  uploadFile(data) {
    return this.request({
      method: 'POST',
      url: `/uploadFile`,
      data,
      params: { apiIndex: `${Math.random() * 100}` }
    });
  }
  // oss上传配置
  getOssBasePath() {
    return this.request({
      method: 'GET',
      url: `/sts-token`,
      params: { apiIndex: `${Math.random() * 100}` }
    });
  }
  // 下载附件
  downloadFile(url) {
    return this.request({
      method: 'GET',
      url: url,
      responseType: 'blob',
      notAuth: true
    });
  }
  // 下载附件预签名url
  getPresignedUrl(params) {
    return this.request({
      method: 'GET',
      url: `/oss/presignedObjectUrl`,
      params
    });
  }
  // 消息卡片-附件地址下载中转页面
  getOssRedirect(url) {
    return this.request({
      method: 'GET',
      url: '/oss/redirect/' + url
    });
  }
}
export const publicService = new PublicService();
